import React, { useState } from 'react';
import api from '../api';

// Mesma identidade visual usada em Financeiro.js (Navy/Orange do Sobraa)
const cores = {
  navy: '#1A2233', border: '#d4dde8', muted: '#6b7a8d',
  orange: '#D85A30', orangeHover: '#B84A24', bg: '#f5f7fa', card: '#ffffff',
  red: '#e74c3c',
};

const inputStyle = { width: '100%', padding: '9px 12px', border: `1.5px solid ${cores.border}`, borderRadius: 8, fontSize: 14, boxSizing: 'border-box' };
const labelStyle = { fontSize: 12, fontWeight: 700, color: cores.muted, display: 'block', marginBottom: 4, textTransform: 'uppercase' };
const btnPrimary = { padding: '10px 20px', background: cores.orange, color: 'white', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: 'pointer' };
const btnGhost = { padding: '10px 20px', background: '#f0f3f7', color: cores.muted, border: `1px solid ${cores.border}`, borderRadius: 8, fontWeight: 600, fontSize: 14, cursor: 'pointer' };

const Secao = ({ titulo, children }) => (
  <div style={{ marginBottom: 22 }}>
    <div style={{ fontSize: 13, fontWeight: 800, color: cores.navy, marginBottom: 10, paddingBottom: 6, borderBottom: `1px solid ${cores.border}` }}>
      {titulo}
    </div>
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
      {children}
    </div>
  </div>
);

const Campo = ({ label, full, children }) => (
  <div style={full ? { gridColumn: '1 / -1' } : undefined}>
    <label style={labelStyle}>{label}</label>
    {children}
  </div>
);

const ESTADO_INICIAL = {
  // Dados gerais
  cfop: '6353',
  natureza_operacao: 'Prestação de serviço de transporte',
  icms_situacao_tributaria: '00',

  // Trajeto
  municipio_inicio: '', uf_inicio: '',
  municipio_fim: '', uf_fim: '',
  retirar_mercadoria: '1', // 1 = Não (entrega no destinatário)
  detalhes_retirar: 'Entrega no endereço do destinatário',

  // Remetente
  remetente_nome: '', remetente_doc_tipo: 'cnpj', remetente_cnpj: '', remetente_cpf: '',
  remetente_ie: '', remetente_telefone: '', remetente_logradouro: '', remetente_numero: '',
  remetente_bairro: '', remetente_municipio: '', remetente_uf: '',

  // Destinatário
  destinatario_nome: '', destinatario_doc_tipo: 'cnpj', destinatario_cnpj: '', destinatario_cpf: '',
  destinatario_ie: '', destinatario_telefone: '', destinatario_logradouro: '', destinatario_numero: '',
  destinatario_bairro: '', destinatario_municipio: '', destinatario_uf: '', destinatario_cep: '',

  // Tomador do serviço (quem paga o frete)
  tomador: '0', // 0=Remetente 1=Expedidor 2=Recebedor 3=Destinatário 4=Outros
  indicador_ie_tomador: '9',
  tomador_nome: '', tomador_doc_tipo: 'cnpj', tomador_cnpj: '', tomador_cpf: '',
  tomador_telefone: '', tomador_logradouro: '', tomador_numero: '',
  tomador_bairro: '', tomador_municipio: '', tomador_uf: '', tomador_cep: '',

  // Carga e valores
  valor_total: '', valor_total_carga: '', produto_predominante: '', peso_kg: '',
  tipo_medida: 'PESO BRUTO',
};

const UFS = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

const ICMS_OPCOES = [
  { v: '00', l: '00 — Tributada integralmente' },
  { v: '20', l: '20 — Tributada com redução de base de cálculo' },
  { v: '40', l: '40 — Isenta' },
  { v: '41', l: '41 — Não tributada' },
  { v: '51', l: '51 — Diferimento' },
  { v: '60', l: '60 — Cobrado anteriormente por substituição tributária' },
  { v: '90', l: '90 — Outros (Regime Normal)' },
  { v: '90_simples_nacional', l: '90 — Outros (Simples Nacional)' },
];

function UFSelect({ value, onChange }) {
  return (
    <select value={value} onChange={onChange} style={inputStyle}>
      <option value="">UF</option>
      {UFS.map(uf => <option key={uf} value={uf}>{uf}</option>)}
    </select>
  );
}

// Bloco de pessoa (Nome + CNPJ/CPF + Telefone + Endereço), reaproveitado para
// Remetente, Destinatário e Tomador (quando tomador = Outros)
function BlocoPessoa({ prefixo, form, setCampo, comCep, comIE }) {
  const tipoDoc = form[`${prefixo}_doc_tipo`];
  return (
    <>
      <Campo label="Nome / Razão Social" full>
        <input value={form[`${prefixo}_nome`]} onChange={e => setCampo(`${prefixo}_nome`, e.target.value)}
          placeholder="Nome ou razão social" style={inputStyle} />
      </Campo>
      <Campo label="Tipo de Documento">
        <select value={tipoDoc} onChange={e => setCampo(`${prefixo}_doc_tipo`, e.target.value)} style={inputStyle}>
          <option value="cnpj">CNPJ</option>
          <option value="cpf">CPF</option>
        </select>
      </Campo>
      <Campo label={tipoDoc === 'cnpj' ? 'CNPJ' : 'CPF'}>
        <input value={form[`${prefixo}_${tipoDoc}`]} onChange={e => setCampo(`${prefixo}_${tipoDoc}`, e.target.value)}
          placeholder={tipoDoc === 'cnpj' ? '00.000.000/0000-00' : '000.000.000-00'} style={inputStyle} />
      </Campo>
      {comIE && (
        <Campo label="Inscrição Estadual">
          <input value={form[`${prefixo}_ie`]} onChange={e => setCampo(`${prefixo}_ie`, e.target.value)}
            placeholder="Deixe vazio se isento/não contribuinte" style={inputStyle} />
        </Campo>
      )}
      <Campo label="Telefone">
        <input value={form[`${prefixo}_telefone`]} onChange={e => setCampo(`${prefixo}_telefone`, e.target.value)}
          placeholder="(00) 00000-0000" style={inputStyle} />
      </Campo>
      <Campo label="Logradouro">
        <input value={form[`${prefixo}_logradouro`]} onChange={e => setCampo(`${prefixo}_logradouro`, e.target.value)}
          placeholder="Rua, avenida..." style={inputStyle} />
      </Campo>
      <Campo label="Número">
        <input value={form[`${prefixo}_numero`]} onChange={e => setCampo(`${prefixo}_numero`, e.target.value)}
          placeholder="Nº" style={inputStyle} />
      </Campo>
      <Campo label="Bairro">
        <input value={form[`${prefixo}_bairro`]} onChange={e => setCampo(`${prefixo}_bairro`, e.target.value)}
          placeholder="Bairro" style={inputStyle} />
      </Campo>
      <Campo label="Município">
        <input value={form[`${prefixo}_municipio`]} onChange={e => setCampo(`${prefixo}_municipio`, e.target.value)}
          placeholder="Cidade" style={inputStyle} />
      </Campo>
      <Campo label="UF">
        <UFSelect value={form[`${prefixo}_uf`]} onChange={e => setCampo(`${prefixo}_uf`, e.target.value)} />
      </Campo>
      {comCep && (
        <Campo label="CEP">
          <input value={form[`${prefixo}_cep`]} onChange={e => setCampo(`${prefixo}_cep`, e.target.value)}
            placeholder="00000-000" style={inputStyle} />
        </Campo>
      )}
    </>
  );
}

export default function CteModal({ toast, onClose, onSucesso }) {
  const [form, setForm] = useState(ESTADO_INICIAL);
  const [salvando, setSalvando] = useState(false);

  const setCampo = (chave, valor) => setForm(p => ({ ...p, [chave]: valor }));

  const validar = () => {
    const obrigatorios = [
      ['cfop', 'CFOP'],
      ['municipio_inicio', 'Município de Início'],
      ['uf_inicio', 'UF de Início'],
      ['municipio_fim', 'Município de Fim'],
      ['uf_fim', 'UF de Fim'],
      ['remetente_nome', 'Nome do Remetente'],
      ['destinatario_nome', 'Nome do Destinatário'],
      ['valor_total', 'Valor Total da Prestação'],
    ];
    for (const [chave, label] of obrigatorios) {
      if (!String(form[chave] || '').trim()) return `Preencha: ${label}`;
    }
    if (isNaN(parseFloat(form.valor_total)) || parseFloat(form.valor_total) <= 0) {
      return 'Valor Total da Prestação deve ser maior que zero.';
    }
    const remDoc = form[`remetente_${form.remetente_doc_tipo}`];
    if (!remDoc || !remDoc.replace(/\D/g, '')) return 'Informe o CNPJ ou CPF do Remetente.';
    const destDoc = form[`destinatario_${form.destinatario_doc_tipo}`];
    if (!destDoc || !destDoc.replace(/\D/g, '')) return 'Informe o CNPJ ou CPF do Destinatário.';
    if (form.tomador === '4' && !String(form.tomador_nome || '').trim()) {
      return 'Tomador = "Outros" exige nome/razão social do tomador.';
    }
    return null;
  };

  const salvar = async () => {
    const erro = validar();
    if (erro) { toast(erro, 'error'); return; }

    setSalvando(true);
    try {
      const payload = { ...form };
      // Normaliza o campo de documento genérico (CNPJ ou CPF) para o nome
      // esperado pelo backend, independente do toggle escolhido na tela.
      ['remetente', 'destinatario', 'tomador'].forEach(p => {
        const tipo = form[`${p}_doc_tipo`];
        if (tipo === 'cnpj') delete payload[`${p}_cpf`];
        else delete payload[`${p}_cnpj`];
      });

      const { data } = await api.post('/notas/cte/emitir', payload);
      toast('CT-e enviado para processamento!', 'success');
      onSucesso && onSucesso(data);
    } catch (e) {
      const msg = e?.response?.data?.erro || 'Erro ao emitir CT-e.';
      toast(msg, 'error');
    }
    setSalvando(false);
  };

  return (
    <div onClick={e => e.target === e.currentTarget && onClose()}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 1200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: cores.card, borderRadius: 16, width: '100%', maxWidth: 760, maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 64px rgba(0,0,0,0.25)' }}>

        {/* Header */}
        <div style={{ padding: '18px 24px', borderBottom: `1px solid ${cores.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ fontWeight: 800, fontSize: 16, color: cores.navy }}>🚚 Emitir CT-e</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: cores.muted }}>✕</button>
        </div>

        {/* Corpo */}
        <div style={{ overflowY: 'auto', padding: '20px 24px', flex: 1, background: cores.bg }}>

          <Secao titulo="📋 Dados Gerais">
            <Campo label="CFOP">
              <input value={form.cfop} onChange={e => setCampo('cfop', e.target.value)} placeholder="6353" style={inputStyle} />
            </Campo>
            <Campo label="Situação Tributária do ICMS">
              <select value={form.icms_situacao_tributaria} onChange={e => setCampo('icms_situacao_tributaria', e.target.value)} style={inputStyle}>
                {ICMS_OPCOES.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
              </select>
            </Campo>
            <Campo label="Natureza da Operação" full>
              <input value={form.natureza_operacao} onChange={e => setCampo('natureza_operacao', e.target.value)} style={inputStyle} />
            </Campo>
          </Secao>

          <Secao titulo="🗺️ Trajeto">
            <Campo label="Município de Início">
              <input value={form.municipio_inicio} onChange={e => setCampo('municipio_inicio', e.target.value)} placeholder="Cidade de origem" style={inputStyle} />
            </Campo>
            <Campo label="UF de Início">
              <UFSelect value={form.uf_inicio} onChange={e => setCampo('uf_inicio', e.target.value)} />
            </Campo>
            <Campo label="Município de Fim">
              <input value={form.municipio_fim} onChange={e => setCampo('municipio_fim', e.target.value)} placeholder="Cidade de destino" style={inputStyle} />
            </Campo>
            <Campo label="UF de Fim">
              <UFSelect value={form.uf_fim} onChange={e => setCampo('uf_fim', e.target.value)} />
            </Campo>
            <Campo label="Retirada da Mercadoria">
              <select value={form.retirar_mercadoria} onChange={e => setCampo('retirar_mercadoria', e.target.value)} style={inputStyle}>
                <option value="1">Não (entrega no destinatário)</option>
                <option value="0">Sim (retirada por conta do destinatário)</option>
              </select>
            </Campo>
            <Campo label="Detalhes da Retirada">
              <input value={form.detalhes_retirar} onChange={e => setCampo('detalhes_retirar', e.target.value)} style={inputStyle} />
            </Campo>
          </Secao>

          <Secao titulo="📤 Remetente (quem envia a carga)">
            <BlocoPessoa prefixo="remetente" form={form} setCampo={setCampo} comIE />
          </Secao>

          <Secao titulo="📥 Destinatário (quem recebe a mercadoria)">
            <BlocoPessoa prefixo="destinatario" form={form} setCampo={setCampo} comCep comIE />
          </Secao>

          <Secao titulo="💰 Tomador do Serviço (quem paga o frete)">
            <Campo label="Tomador">
              <select value={form.tomador} onChange={e => setCampo('tomador', e.target.value)} style={inputStyle}>
                <option value="0">Remetente</option>
                <option value="1">Expedidor</option>
                <option value="2">Recebedor</option>
                <option value="3">Destinatário</option>
                <option value="4">Outros</option>
              </select>
            </Campo>
            <Campo label="Indicador de IE do Tomador">
              <select value={form.indicador_ie_tomador} onChange={e => setCampo('indicador_ie_tomador', e.target.value)} style={inputStyle}>
                <option value="1">Contribuinte ICMS</option>
                <option value="2">Contribuinte isento de inscrição</option>
                <option value="9">Não Contribuinte</option>
              </select>
            </Campo>
            {form.tomador === '4' && (
              <BlocoPessoa prefixo="tomador" form={form} setCampo={setCampo} comCep />
            )}
          </Secao>

          <Secao titulo="📦 Carga e Valores">
            <Campo label="Valor Total da Prestação (R$)">
              <input type="number" step="0.01" value={form.valor_total} onChange={e => setCampo('valor_total', e.target.value)} placeholder="0,00" style={inputStyle} />
            </Campo>
            <Campo label="Valor Total da Carga (R$)">
              <input type="number" step="0.01" value={form.valor_total_carga} onChange={e => setCampo('valor_total_carga', e.target.value)} placeholder="Se vazio, usa o valor da prestação" style={inputStyle} />
            </Campo>
            <Campo label="Produto Predominante">
              <input value={form.produto_predominante} onChange={e => setCampo('produto_predominante', e.target.value)} placeholder="Ex: Material de construção" style={inputStyle} />
            </Campo>
            <Campo label="Tipo de Medida">
              <select value={form.tipo_medida} onChange={e => setCampo('tipo_medida', e.target.value)} style={inputStyle}>
                <option value="PESO BRUTO">Peso Bruto</option>
                <option value="PESO DECLARADO">Peso Declarado</option>
                <option value="PESO CUBADO">Peso Cubado</option>
                <option value="PESO AFERIDO">Peso Aferido</option>
                <option value="PESO BASE DE CALCULO">Peso Base de Cálculo</option>
                <option value="LITRAGEM">Litragem</option>
                <option value="UNIDADE">Unidade</option>
                <option value="CAIXAS">Caixas</option>
              </select>
            </Campo>
            <Campo label="Peso (kg)">
              <input type="number" step="0.01" value={form.peso_kg} onChange={e => setCampo('peso_kg', e.target.value)} placeholder="0,00" style={inputStyle} />
            </Campo>
          </Secao>

          <div style={{ fontSize: 12, color: cores.muted, marginTop: -6 }}>
            O RNTRC e os dados do emitente são preenchidos automaticamente a partir do cadastro da empresa em Configurações → Integrações → Focus NFe.
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: '14px 24px', borderTop: `1px solid ${cores.border}`, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button onClick={onClose} style={btnGhost} disabled={salvando}>Cancelar</button>
          <button onClick={salvar} style={{ ...btnPrimary, opacity: salvando ? 0.7 : 1 }} disabled={salvando}>
            {salvando ? 'Emitindo...' : '🚚 Emitir CT-e'}
          </button>
        </div>
      </div>
    </div>
  );
}
